import { Box, Skeleton } from "@mui/material";

const AVATAR_SIZE = 30;

function UserRowSkeleton({ widths }: { widths: string[] }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row-reverse",
        alignItems: "flex-start",
        gap: 1.25,
        px: { xs: 1.5, sm: 3 },
        py: 1,
      }}
    >
      <Skeleton
        variant="circular"
        width={AVATAR_SIZE}
        height={AVATAR_SIZE}
        sx={{ mt: 0.25, flexShrink: 0 }}
      />
      <Box sx={{ maxWidth: { xs: "85%", sm: "72%" }, minWidth: 0 }}>
        <Box
          sx={{
            bgcolor: "accent.soft",
            border: "1px solid",
            borderColor: "border.accent",
            borderRadius: 2.5,
            px: 2,
            py: 1.25,
          }}
        >
          {widths.map((w, i) => (
            <Skeleton
              key={`${i}-${w}`}
              variant="text"
              width={w}
              sx={{ fontSize: "0.9375rem" }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function AssistantRowSkeleton({ widths }: { widths: string[] }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 1.25,
        px: { xs: 1.5, sm: 3 },
        py: 1,
      }}
    >
      <Skeleton
        variant="circular"
        width={AVATAR_SIZE}
        height={AVATAR_SIZE}
        sx={{ mt: 0.25, flexShrink: 0 }}
      />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {widths.map((w, i) => (
          <Skeleton
            key={`${i}-${w}`}
            variant="text"
            width={w}
            sx={{ fontSize: "0.9375rem" }}
          />
        ))}
      </Box>
    </Box>
  );
}

export function ChatSkeleton() {
  return (
    <Box
      component="output"
      aria-label="Loading conversation"
      aria-live="polite"
      sx={{ width: "100%", py: 1, display: "block" }}
    >
      <UserRowSkeleton widths={["70%", "45%"]} />
      <AssistantRowSkeleton widths={["95%", "92%", "88%", "60%"]} />
      <UserRowSkeleton widths={["55%"]} />
      <AssistantRowSkeleton widths={["90%", "85%", "70%"]} />
    </Box>
  );
}
